import { Component, OnInit, OnDestroy } from '@angular/core';

import { Subscription } from 'rxjs/Subscription';
import { Observable } from 'rxjs/Observable';
import { Store } from '@ngrx/store';
import { IApplicationState } from '../../../stateManagement/states/ApplicationState';
import * as fromRoot from '../../../stateManagement/rootReducer';
import { IToastr } from '../../../shared/types';
import { Router, ActivatedRoute } from '@angular/router';
import { DisableBusyFlag } from '../../../stateManagement/actions/containers/application';
@Component({
  selector: 'tr-error-container',
  templateUrl: './error-container.component.html',
  //styleUrls: ['./error-container.component.scss']
})
export class ErrorContainerComponent implements OnInit, OnDestroy {
  
  subscriptions: Array<Subscription> = [];
  errorBody: string[];
  errorTitle: string;
  errors: IToastr[];
  errorCode: string;

  constructor( private store: Store<IApplicationState>, private router: Router, private route: ActivatedRoute) {
    this.store.dispatch(new DisableBusyFlag({}));
    //this.subscriptions.push(this.route.queryParams.subscribe(params => this.errorCode = params['code'] || ''));
  }

  ngOnInit() {
    this.subscriptions.push(
      this.store.select(fromRoot.getApplicationNotifications)
      .subscribe((notifications: IToastr[]) => {
        if (notifications.length === 0) {
          this.router.navigate(['']);
        }
        this.errors = notifications;
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
}




// WEBPACK FOOTER //
// ./src/app/shared/containers/error-container/error-container.component.ts